import { useTheme } from '../../contexts/ThemeContext';

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="w-10 h-10 flex items-center justify-center rounded-full transition-all duration-200 hover:bg-gray-100 dark:hover:bg-[#1E2337] cursor-pointer"
      aria-label="Toggle theme"
    >
      {theme === 'dark' ? (
        <i className="ri-sun-line text-xl text-[#94A3B8] hover:text-white transition-colors"></i>
      ) : (
        <i className="ri-moon-line text-xl text-gray-600 hover:text-gray-900 transition-colors"></i>
      )}
    </button>
  );
}
